/**
 * ui-library buttons (`.btn`) answer Enter twice: they emit their own click on keydown, and the
 * browser then clicks the focused button as it does for any button. Every @click on one ran twice
 * from the keyboard — a menu opened and shut again, Back skipped a step, a print went out twice —
 * while a handler on a wrapper heard only the browser's click.
 *
 * The browser's click is the one to keep: it is the one Space gives too, and the one wrappers and
 * dropdown triggers listen for. So Enter on such a button is stopped before it reaches the button's
 * own keydown handling; the browser still clicks it, once.
 *
 * Two exceptions keep dropdowns working:
 * - it is taken on the document's way down, after the library has noted the key came from the
 *   keyboard (a dropdown opened that way highlights its current option);
 * - while the button's own menu is open, Enter is left alone — the menu runs its highlighted item.
 */
export default defineNuxtPlugin(() => {
  document.addEventListener(
    "keydown",
    (event) => {
      if (event.key !== "Enter" || event.altKey || event.ctrlKey || event.metaKey) return;
      const target = event.target as HTMLElement | null;
      if (!target?.matches("button.btn, a.btn")) return;
      if (target.closest("[data-popper-shown]")) return;
      event.stopPropagation();
    },
    true
  );
});
